import Vue from 'vue';
import _store from '@/store';

export {_store as store};

//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Variable                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//
export const state = {
  store: _store.state,
  // States from Vuex store
  local: Vue.observable({
    // Setup local state here (States which don't shared or long-term keeping);

    isProcessing: true,

    //manual data
    selectedDegree: null,
    selectedSubjectGroup: null,
    selectedSubject: null,
    selectedTeacher: null,
    selectedAcademicPeriod: null,
    currentAcademicPeriod: null,
    subjects: [],
    liveClassSchedules: [],


    //vdoLiveSet edit
    vdoLiveSetEdit: {
      vdoLiveSet: null,
    },
    //vdoLiveSetTopic edit
    vdoLiveSetTopicEdit: {
      selectedVdoLiveSetTopic: null,
      vdoLiveSetTopics: [],

      form: {
        id: '',
        vdoLiveSetTopicInput: {
          no: 1,
          nameLocal: '',
          nameEng: '',
          vdoLength: 0,
          vdoStreamPath: '',
        }
      }
    },


  })
};

export const template = {
  table: {
    header: [
      {title: 'live-class-schedule.no', id: 'no'},
      {title: 'live-class-schedule.subject-code', id: 'subjectCode', width: 200},
      // {title: 'live-class-schedule.subject-name', id: 'subjectName'},
      {title: 'live-class-schedule.on-air-time', id: 'onAirTtime', width: 150},
      {title: 'live-class-schedule.teacher', id: 'teacher', width: 200},
      // {title: 'live-class-schedule.section', id: 'classSectionQty'},
      // {title: 'live-class-schedule.unit', id: 'courseOutlineUnit'},
      {title: 'live-class-schedule.topic', id: 'topic'},
      {title: 'live-class-schedule.remark', id: 'remark'},
      {title: 'live-class-schedule.is-enabled', id: 'isEnabled', width: 100},
      {title: '', id: '', width: 30},
    ]
  },
};


//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Function                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//

export const initData = async (func) => {
  //use state
  if (func.getAcademicPeriods && (!state.store.AcademicPeriod.academicPeriods || state.store.AcademicPeriod.academicPeriods.length === 0)) {
    await func.getAcademicPeriods();
  }
  if (func.getDegrees && (!state.store.Degree.degrees || state.store.Degree.degrees.length === 0)) {
    await func.getDegrees();
  }
  if (func.getSubjectGroups && (!state.store.SubjectGroup.subjectGroups || state.store.SubjectGroup.subjectGroups.length === 0)) {
    await func.getSubjectGroups();
  }
  if (func.getTeachersDdl && (!state.store.Teacher.teachers || state.store.Teacher.teachers.length === 0)) {
    await func.getTeachersDdl();
  }

  //use local
  if (func.getCurrentAcademicPeriodConfig && !state.local.academicPeriodConfig) {
    state.local.currentAcademicPeriod = await func.getCurrentAcademicPeriodConfig();
    state.local.selectedAcademicPeriod = state.store.AcademicPeriod.academicPeriods.find(item => {
      return item.periodCode === state.local.currentAcademicPeriod.learnPeriodCode
    });
  }

};

export const loadData = async (func) => {
  let payload = {
    liveClassScheduleFilterInput: {
      academicPeriodId: state.local.selectedAcademicPeriod ? state.local.selectedAcademicPeriod.id : '',
      degreeId: state.local.selectedDegree ? state.local.selectedDegree.id : '',
      subjectGroupId: state.local.selectedSubjectGroup ? state.local.selectedSubjectGroup.id : '',
      subjectId: state.local.selectedSubject ? state.local.selectedSubject.id : '',
      teacherId: state.local.selectedTeacher ? state.local.selectedTeacher.id : '',
      // isEnabled: true,
    }
  };
  if (func.getLiveClassSchedulesByFilterForTable) {
    state.local.liveClassSchedules = await func.getLiveClassSchedulesByFilterForTable(payload);
  }

};

export const setEmptyVdoLiveSetTopicForm = () => {
  state.local.vdoLiveSetTopicEdit.selectedVdoLiveSetTopic = null

  let no = 1;
  if (state.local.vdoLiveSetTopicEdit.vdoLiveSetTopics
    && state.local.vdoLiveSetTopicEdit.vdoLiveSetTopics.length > 0) {
    no = state.local.vdoLiveSetTopicEdit.vdoLiveSetTopics.length + 1;
  }
  state.local.vdoLiveSetTopicEdit.form.vdoLiveSetTopicInput.no = no;
  state.local.vdoLiveSetTopicEdit.form.vdoLiveSetTopicInput.nameLocal = '';
  state.local.vdoLiveSetTopicEdit.form.vdoLiveSetTopicInput.nameEng = '';
  state.local.vdoLiveSetTopicEdit.form.vdoLiveSetTopicInput.vdoLength = '';
  state.local.vdoLiveSetTopicEdit.form.vdoLiveSetTopicInput.vdoStreamPath = '';
}

//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Private Function                                                      //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//
